module.exports = __webpack_public_path__ + "static/img/logo-patrim.d52ef96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/logo-patrim.svg
// module id = 947
// module chunks = 0